import { CategoryKey, OptionType } from '@aibees/shared/features';

// Single source of truth for what counts as a Profile Insight export field.
//
// Both consumers below read from these lists so the per-field info badge in the
// template dialog (see options-converter `getFieldHasInfoBadge`) and the
// export-time mismatch warning (see `hasProfileInsightFields`) can never drift
// apart. Previously the badge matched on display-name substrings while the
// warning matched on OptionType keys, so `SLUG` got a badge but never triggered
// the warning.

// Category-level Profile Insight sources: selecting any field inside one of
// these categories counts as requesting Profile Insight data.
export const PROFILE_INSIGHT_CATEGORIES: string[] = [
  CategoryKey.companyLocations,
  CategoryKey.experiences,
  CategoryKey.educations,
  CategoryKey.awards,
  CategoryKey.courses,
  CategoryKey.projects,
  CategoryKey.languages,
  CategoryKey.certifications,
  CategoryKey.volunteerExperiences,
  CategoryKey.publications,
  CategoryKey.patents,
];

// Individual Profile Insight columns (People Basic). Keyed by OptionType, which
// is the same value used as the export column `fieldKey`.
export const PROFILE_INSIGHT_FIELDS: string[] = [
  OptionType.HEADLINE,
  OptionType.SUMMARY,
  OptionType.SKILLS,
  OptionType.INFLUENCER,
  OptionType.OPEN_TO_WORK,
  OptionType.PREMIUM,
  OptionType.CREATOR,
  OptionType.DATE_OF_BIRTH,
  OptionType.JOB_COUNT,
  OptionType.PROFILE_PICTURE,
  OptionType.SLUG,
];

// Is this export column key a Profile Insight field? `fieldKey` is the
// OptionType value carried by each export column.
export function isProfileInsightField(fieldKey: string): boolean {
  return PROFILE_INSIGHT_FIELDS.includes(fieldKey);
}
